import type { TFunction } from 'i18next';

export interface FilterDict {
  key: string;
  name: string;
}

export const getFilterDict = (
  t: TFunction<'solve-analytics'>,
): Array<FilterDict> => [
  {
    key: 'all',
    name: t('filters.allMacrosAndArticles'),
  },
  {
    key: 'macro',
    name: t('filters.onlyMacros'),
  },
  {
    key: 'article',
    name: t('filters.onlyArticles'),
  },
];

export const getWorkflowsFilterDict = (
  t: TFunction<'solve-analytics'>,
): Array<FilterDict> => [
  {
    key: 'table-workflow',
    name: t('filters.allWorkflows'),
  },
  {
    key: 'table-knowledge',
    name: t('filters.allArticles'),
  },
];
